import { render, staticRenderFns } from "./ControlDateBadge.vue?vue&type=template&id=64f12bb5&"
import script from "./ControlDateBadge.vue?vue&type=script&lang=js&"
export * from "./ControlDateBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports